import { Component } from 'react'

type FileInputProps = {
  onChange: (files: File[]) => void
  images?: boolean
  multiple?: boolean
}

export class FileInput extends Component<FileInputProps> {
  private inputNode = document.createElement('input')

  render () {
    const {
      children,
    } = this.props

    return (
      <div
        onClick={ () => this.inputNode.click() }
      >
        { children }
      </div>
    )
  }

  componentDidMount () {
    const { images, multiple } = this.props
    this.inputNode.type = 'file'
    if (images) {
      this.inputNode.accept = 'image/*'
    }
    if (multiple) {
      this.inputNode.multiple = true
    }
    this.inputNode.addEventListener('change', this.handleChange, true)
  }

  componentWillUnmount () {
    this.inputNode.removeEventListener('change', this.handleChange, true)
  }

  private handleChange = () => {
    const { onChange } = this.props
    const files = this.inputNode.files
    if (files && files.length > 0) {
      onChange(Array.from(files))
      this.inputNode.value = ''
    }
  }
}
